export default __webpack_public_path__ + "static/media/bball_220x220.c96013ea.png";